export const bookingPlatforms = [
  {
    name: 'Booking.com',
    priceKey: 'bookingComPrice',
    url: 'https://www.booking.com/hotel/lk/k-and-sons-guest-house.en-gb.html?aid=356980&label=gog235jc-10CAsohQFCFmstYW5kLXNvbnMtZ3Vlc3QtaG91c2VIM1gDaMkBiAEBmAEzuAEHyAEM2AED6AEB-AEBiAIBqAIBuAK8ypHXBsACAdICJDVkMzc1MzNhLTExN2ItNDI3ZS1iMjFlLWY4ZTI0YjQyMDE0YtgCAeACAQ&sid=0a7479c03618ff75e2a109865bb875cf&all_sr_blocks=1752191404_446557569_2_0_0&checkin=2026-11-28&checkout=2026-11-29&dest_id=-2230513&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&highlighted_blocks=1752191404_446557569_2_0_0&hpos=1&matching_block_id=1752191404_446557569_2_0_0&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&sr_pri_blocks=1752191404_446557569_2_0_0__2080&srepoch=1793781822&srpvid=a87e3d5d1cac00d6&type=total&ucfs=1&'
  },
  {
    name: 'Agoda.com',
    priceKey: 'agodaPrice',
    url: 'https://www.agoda.com/en-gb/en-gb/k-and-sons-guest-house/hotel/negombo-lk.html'
  }
];